const routes = {
    orderModificationSummary: "/orderModificationSummary",
    modifiedOrderSummary: "/modifiedOrderSummary",
    rejectedOrderModification: "/rejectedOrderModification",
}

export default routes;